import QueriesListItem from './QueriesListItem';

export default QueriesListItem;
